import { PlatformType } from '@okletsplay/core';

export const usePlatformType = (platformType?: PlatformType) => {
  if (!platformType) {
    return false;
  }

  return [PlatformType.Olp, PlatformType.Colyseus, PlatformType.BubbleUpEndless].includes(
    platformType
  );
};
